"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MapPin, Phone, Facebook, Twitter, Instagram } from "lucide-react";
const locations = [{
  id: "loc-1",
  name: "Dear EXA Studio",
  address: "香港 觀塘 創意工作室 (預約制)"
}, {
  id: "loc-2",
  name: "合作空間 Partner Space",
  address: "各區社區中心及學校合作點"
}, {
  id: "loc-3",
  name: "攝影散步地點",
  address: "隨影像流動的城市角落"
}];
const socials = [{
  id: "soc-1",
  icon: Instagram,
  label: "Instagram",
  href: "https://instagram.com"
}, {
  id: "soc-2",
  icon: Phone,
  label: "WhatsApp",
  href: "https://wa.me"
}, {
  id: "soc-3",
  icon: Instagram,
  label: "Email",
  href: "mailto:hello@dearexa.com"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map(i => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors text-sm tracking-wider">首頁 Home</Link>
        </li>
        <li data-index={1}>
          <Link to="/AboutPage" className="text-muted-foreground hover:text-primary transition-colors text-sm tracking-wider">關於 About</Link>
        </li>
        <li data-index={2}>
          <Link to="/TeachingAndServicesPage" className="text-muted-foreground hover:text-primary transition-colors text-sm tracking-wider">服務 Services</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm tracking-wider">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="265041" id="footer" className="bg-background border-t border-secondary pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto grayscale opacity-80" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6 font-default">
              有些話，未必能說出口。但也許，能被慢慢創作出來。Dear EXA 是一個溫柔的空間，讓藝術成為陪伴，探索內在的聲音。
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-widest">
              導覽 Explore
            </h3>
            <MenuProvider menu_id="41">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-widest">
              聯繫方式 Contact
            </h3>
            <ul className="space-y-5">
              {locations.map((loc, i) => <li key={loc.id} data-index={i} className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 text-muted-foreground shrink-0 mt-1" />
                  <div className="flex flex-col gap-1">
                    <span className="text-sm font-default font-medium text-foreground">{loc.name}</span>
                    <span className="text-xs text-muted-foreground leading-snug">{loc.address}</span>
                  </div>
                </li>)}
              <li className="flex items-center gap-3 pt-2">
                <Phone className="w-4 h-4 text-muted-foreground shrink-0" />
                <span className="text-xs text-muted-foreground tracking-widest">DEAR-EXA-ARTS</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-widest">
              追蹤動態 Follow
            </h3>
            <div className="flex items-center gap-4 mb-8">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.id} to={social.href} data-index={i} className="w-10 h-10 rounded-md bg-secondary flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-500" aria-label={social.label}>
                    <Icon className="w-4 h-4" />
                  </Link>;
            })}
            </div>
            <div className="bg-secondary/30 p-5 rounded-md border border-border">
              <h4 className="font-default font-medium text-foreground mb-2 text-sm">讓創作成為你的陪伴</h4>
              <p className="text-xs text-muted-foreground mb-4 leading-relaxed">歡迎預約個人諮詢或機構工作坊合作。</p>
              <Button asChild className="w-full bg-primary text-primary-foreground hover:opacity-90 rounded-md font-default text-xs tracking-widest">
                <Link to="/TeachingAndServicesPage">開始創作之旅</Link>
              </Button>
            </div>
          </div>

        </div>

        <Separator className="my-10 bg-secondary" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground font-default tracking-widest">
          <p>© {currentYear} Dear EXA. 親愛的表達藝術. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">隱私條款 Privacy</Link>
            <Link to="#" className="hover:text-foreground transition-colors">使用須知 Terms</Link>
          </div>
        </div>
      </div>
    </section>;
}